import React from 'react';
import { BlockComponentProps } from 'client-react-block-renderer/src';
import { HashRouter, Route, Redirect, Switch } from 'react-router-dom';
import StepRoute from './features/current-step/StepRoute';
import './app.scss';
import { BlockConfig } from './types';
interface Props extends BlockComponentProps<Data, BlockConfig> { }
interface Data { }

const App = (props: Props) => {
    const steps = [
        {
            label: props.config.welcomePageHeadingText,
            stepType: 'welcome' as const,
            headingText: '',
            middleHeadingText: props.config.welcomePageHeadingText,
            bodyHtml: props.config.welcomePageBodyText
        },
        ...props.config.videoWithQuizSteps.map(
            (videoWithQuizStep) => (
                {
                    label: videoWithQuizStep.headingText,
                    stepType: 'videoWithQuiz' as const,
                    ...videoWithQuizStep,
                }
            )
        ),
        ...props.config.readAndAcceptSteps.map(
            (readAndAcceptStep) => (
                {
                    label: readAndAcceptStep.headingText,
                    stepType: 'readAndAccept' as const,
                    ...readAndAcceptStep,
                }
            )
        ),
        {
            label: props.config.congratulationsPageHeadingText,
            stepType: 'congratulations' as const,
            headingText: props.config.congratulationsPageHeadingText,
            video: props.config.congratulationsVideo,
            bodyHtml: props.config.congratulationsPageBodyText
        }
    ];

    return <div className="block-certification-training">
        <HashRouter>
            <Switch>
                <Redirect from="/" exact to="/step/0" />
                <Route path="/step/:stepIndex" render={({ match, history }) =>
                    <StepRoute stepIndex={+match.params.stepIndex} history={history} steps={steps} config={props.config} />
                } />
            </Switch>
        </HashRouter>
    </div>;
};

export default App;
